import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import RichTextComponent from './RichTextComponent';

/**
 * @typedef {import("@prismicio/client").Content.RichTextSlice} RichTextSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<RichTextSlice>} RichTextProps
 * @param { RichTextProps }
 */
const RichText = ({ slice }) => (
  <section>
    <RichTextComponent slice={slice} />
  </section>
);

export default RichText;
